<div class="product-card-addon position-relative">
  <a (click)="goToProduct()" class="product-card-addon__img"
    [class.opacity-50]="(isOOS() || isOOSPerQtty()) && !removable()">
    <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image" />
  </a>
  <div class="product-card-addon__detail">
    <h4 class="title" [class.opacity-50]="(isOOS() || isOOSPerQtty()) && !removable()" ngbTooltip="{{product()?.name}}">
      {{ product()?.name}}
    </h4>

    @if (isOOSPerQtty() && !removable()) {
    <app-empty-message [displayIcon]="true" [tinny]="true" class="text-center" [marginTop0]="true"
      [alertMartginBottom0]="false" [message]="oosMessage()"></app-empty-message>
    } @else {
    <span class="meta">{{ product()?.attribute?.name || product()?.package?.name }}</span>
    <span class="meta">{{ product()?.display }}</span>
    @if ((!isLimitedUser() || isLockedBundle()) && (!removable() || (removable() && !isFixedBundle()))) {
    <h4 class="price">{{ product()?.price | currency }}</h4>
    }
    }
  </div>


  @if (isOOS() && !removable()) {
  <div class="product-card-addon__full-widht">
    <app-empty-message [displayIcon]="true" [marginTop0]="true" [tinny]="true" [alertMartginBottom0]="true"
      [width100]="true" class="text-center" [message]="oosMessage()"></app-empty-message>
  </div>
  } @else {

  <div class="product-card-addon__action">
    @if (!isLockedBundle() || product().isPremiumAddon) {
    <div class="action-input">
      <mat-form-field class="field-small" subscriptSizing="dynamic">
        @if( productCardService.isQuantityHighOrPreviouslyHigh() ){
        <input type="text" matInput appOnlyNumber [maxLength]="2" (keyup)="handleKeyUp($event.target)"
          [value]="productCardService.newQuantity()">
        }
        @else{
        <mat-select [value]="product()?.quantity" (selectionChange)="handleChangeQuantitySelect($event.value)">
          @for(item of availableQuantity(); track $index){
          <mat-option [value]="item.id">{{ item.text }}</mat-option>
          }
        </mat-select>
        }
      </mat-form-field>
    </div>
    <div class="action-btn">
      @if (removable()) {
      <button (click)="remove()" class="btn btn-outline-primary btn-sm px-4 py-2"><span
          class="material-symbols-outlined icon">delete</span><span class="text">Remove</span></button>
      } @else {
      <button (click)="add()" [disabled]="isOOSPerQtty()" class="btn btn-primary btn-sm px-4 py-2"><span
          class="icon">+</span><span class="text">Add</span></button>
      }
    </div>
    } @else {
    <mat-form-field class="d-flex " subscriptSizing="dynamic">
      <input type="text" readonly matInput appOnlyNumber [value]="newQuantity()">
    </mat-form-field>
    }
  </div>

  }
  <!-- Tags Icons -->
  <ul class="product-card__tags">
    @for (tag of product()?.tags || []; track $index) {
    <li>
      @if (tag.icon) {
      <img src="{{tag.icon}}" [alt]="tag.name" [ngbTooltip]="tag.name" />
      } @else {
      <span class="material-symbols-outlined" [ngbTooltip]="tag.name">
        info
      </span>
      }
    </li>
    }
  </ul>
</div>